import "./UserProfile.css";
import React, { Fragment } from "react";
import { Link } from "react-router-dom";
import { UserProfileViewModel } from "./UserProfileViewModel";
import { PulseLoader } from "react-spinners";
import ProfileImg from "../../../Assets/images/profile/1.png";

const UserProfile = () => {
  const { UserData, SchoolName, IsLoading } = UserProfileViewModel();

  return (
    <Fragment>
      {IsLoading ? (
        <PulseLoader
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
          color="#3D5EE1"
          //   size={16}
        />
      ) : (
        <div className="page-wrapper user-profile-page">
          <div className="content container-fluid">
            {/* Page Header */}
            <div className="page-header">
              <div className="row">
                <div className="col">
                  <h3 className="page-title">User Profile</h3>
                </div>
              </div>
            </div>
            {/* /Page Header */}
            <div className="row">
              <div className="col-md-12">
                <div className="profile-header">
                  <div className="row mb-2 align-items-center">
                    <div className="col-auto profile-image">
                      <img
                        className="rounded-circle "
                        alt="User"
                        src={ProfileImg}
                        // src={
                        //   getAuth().currentUser.photoURL
                        //     ? getAuth().currentUser.photoURL
                        //     : require("../../Assets/images/profiles/avatar-02.jpg")
                        // }
                      />
                    </div>
                    <div className="col ms-md-n2 profile-user-info">
                      <h4 className="user-name mb-0">
                        {UserData?.FirstName?.charAt(0)?.toUpperCase() +
                          UserData?.FirstName?.slice(1) +
                          " " +
                          UserData?.LastName?.charAt(0)?.toUpperCase() +
                          UserData?.LastName?.slice(1)}
                      </h4>
                      <h6 className="text-muted  text-capitalize">
                        {UserData?.UserType === "admin"
                          ? "ADMIN"
                          : UserData?.UserType === "teacher"
                          ? "TEACHER"
                          : UserData?.UserType === "student"
                          ? "STUDENT"
                          : UserData?.UserType === "parent"
                          ? "PARENT"
                          : ""}
                      </h6>
                      {UserData?.AdditionalDetails?.PhoneNo && (
                        <div className="user-Location">
                          {UserData?.AdditionalDetails?.PhoneNo}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
                <div className="profile-menu">
                  <ul className="nav nav-tabs nav-tabs-solid">
                    <li className="nav-item">
                      <Link className="nav-link active " data-bs-toggle="tab">
                        About
                      </Link>
                    </li>
                  </ul>
                </div>
                <div className="tab-content profile-tab-cont">
                  <div
                    className="tab-pane fade show active"
                    id="per_details_tab"
                  >
                    <div className="row">
                      <div className="col-lg-9">
                        <div className="card">
                          <div className="card-body">
                            <h5 className="card-title d-flex justify-content-between mb-2">
                              <span>Personal Details</span>
                            </h5>

                            <div className="personal-details-individual-container">
                              <p className="title-for-dynamic-value">Name:</p>
                              <p className="dynamic-value">
                                {UserData?.FirstName?.charAt(0)?.toUpperCase() +
                                  UserData?.FirstName?.slice(1) +
                                  " " +
                                  UserData?.LastName?.charAt(0)?.toUpperCase() +
                                  UserData?.LastName?.slice(1)}
                              </p>
                            </div>

                            <div className="personal-details-individual-container">
                              <p className="title-for-dynamic-value">Gender:</p>
                              <p className="dynamic-value">
                                {UserData?.Gender?.charAt(0)?.toUpperCase() +
                                  UserData?.Gender?.slice(1)}
                              </p>
                            </div>

                            <div className="personal-details-individual-container">
                              <p className="title-for-dynamic-value">
                                Email ID:
                              </p>
                              <p className="dynamic-value">{UserData?.Email}</p>
                            </div>

                            {UserData?.AdditionalDetails?.PhoneNo && (
                              <div className="personal-details-individual-container">
                                <p className="title-for-dynamic-value">
                                  Mobile:
                                </p>
                                <p className="dynamic-value">
                                  {UserData?.AdditionalDetails?.PhoneNo}
                                </p>
                              </div>
                            )}

                            <div className="personal-details-individual-container">
                              <p className="title-for-dynamic-value">
                                School Name:
                              </p>
                              <p className="dynamic-value">{SchoolName}</p>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-3">
                        {/* Account Status */}
                        <div className="card">
                          <div className="card-body">
                            <h5 className="card-title d-flex justify-content-between">
                              <span>Account Status</span>
                            </h5>
                            {UserData?.IsVerified === 0 ? (
                              <button
                                className="btn btn-secondary"
                                type="button"
                              >
                                Pending
                              </button>
                            ) : UserData?.IsVerified === 1 ? (
                              <button className="btn btn-success" type="button">
                                Active
                              </button>
                            ) : UserData?.IsVerified === 2 ? (
                              <button className="btn btn-danger" type="button">
                                Rejected
                              </button>
                            ) : (
                              ""
                            )}
                          </div>
                        </div>
                        {/* /Account Status */}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </Fragment>
  );
};

export default UserProfile;
